import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../lib/auth';
import { formatApiError } from '../lib/format';

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const token = sp.get('token');
  const [state, setState] = useState('loading');
  const [message, setMessage] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (!token) {
      setState('error');
      setMessage('Missing verification token.');
      return;
    }
    api
      .get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(({ data }) => {
        setState('ok');
        setMessage('Your email has been verified.');
        if (data.token && data.user) {
          login(data.token, data.user);
          setTimeout(() => navigate('/dashboard'), 1200);
        }
      })
      .catch((e) => {
        setState('error');
        const detail = formatApiError(e?.response?.data?.detail);
        setMessage(detail);
        toast.error(detail);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div data-testid="verify-page" className="max-w-md mx-auto px-4 sm:px-6 py-20 text-center">
      <div className="card-embossed p-10">
        {state === 'loading' && <Loader2 className="mx-auto animate-spin text-[#D4AF37]" size={40} />}
        {state === 'ok' && <CheckCircle2 className="mx-auto text-[#D4AF37]" size={40} />}
        {state === 'error' && <XCircle className="mx-auto text-[#F87171]" size={40} />}

        <h1 className="mt-6 font-serif-display text-3xl font-black text-gold-gradient">
          {state === 'loading' ? 'Verifying…' : state === 'ok' ? 'Verified!' : 'Verification failed'}
        </h1>
        <p className="mt-3 text-[#C0C0C0]">{message}</p>

        {state === 'error' && (
          <Link to="/login" className="btn-gold mt-6 inline-block">Go to Login</Link>
        )}
      </div>
    </div>
  );
}
